<template #content>
    <Dialog
        :visible="visible"
        @update:visible="updateVisible"
        @show="onShow"
        @hide="onHide"
        class="w-11 lg:w-4"
        modal >
        <template #header>
            <div class="flex justify-content-between flex-wrap w-full">
                <div>
                    <span class="font-bold">Cliente</span>
                </div>

                <div class="flex justify-content-end gap-1">
                    <Button
                        v-if="form.id"
                        label="Log"
                        severity="secondary"
                        icon="pi pi-history"
                        size="small"
                        class="flex align-items-center justify-content-center"
                        @click="openLogForm"
                        :loading="isLoading" />
                </div>
            </div>
        </template>
        <form @submit.prevent="onSubmit(form)">
            <!-- <FormTabPrincipal :form="form" :errors="errors" @consultaCep="consultaCep" /> -->

            <div class="w-full">

                <div class="field mt-4">
                    <FloatLabel>
                        <InputText id="nome" v-model="form.nome" class="w-full" />
                        <label for="nome">Nome<span class="text-red-500">*</span></label>
                    </FloatLabel>
                    <div class="text-xs text-red-500">{{ errors['nome'] }}</div>
                </div>

                <div class="field mt-4">
                    <FloatLabel>
                        <InputText id="documento" v-model="form.documento" class="w-full" />
                        <label for="documento">CPF/CNPJ</label>
                    </FloatLabel>
                    <div class="text-xs text-red-500">{{ errors['documento'] }}</div>
                </div>
                <div class="field mt-4">
                    <FloatLabel>
                        <InputText id="telefone" v-model="form.telefone" class="w-full" />
                        <label for="telefone">Telefone</label>
                    </FloatLabel>
                    <div class="text-xs text-red-500">{{ errors['telefone'] }}</div>
                </div>
                <div class="field mt-4">
                    <FloatLabel>
                        <InputText id="email" v-model="form.email" class="w-full" />
                        <label for="email">E-mail</label>
                    </FloatLabel>
                    <div class="text-xs text-red-500">{{ errors['email'] }}</div>
                </div>

                <div class="field mt-4">
                    <InputGroup>
                        <InputGroupAddon>R$</InputGroupAddon>
                        <FloatLabel>
                            <InputNumber id="valor_referencia" v-model="form.valor_referencia" :minFractionDigits="2" :maxFractionDigits="5" class="w-full" fluid />
                            <label for="valor_referencia">Valor de Referência</label>
                        </FloatLabel>
                    </InputGroup>
                    <div class="text-xs text-red-500">{{ errors['valor_referencia'] }}</div>
                </div>

                <div class="field mt-4">
                    <InputGroup>
                        <FloatLabel>
                            <InputNumber id="duracao" v-model="form.duracao" class="w-full" fluid />
                            <label for="duracao">Duração</label>
                        </FloatLabel>
                        <InputGroupAddon>&nbsp;mêses&nbsp;</InputGroupAddon>
                    </InputGroup>
                </div>
            </div>

            <div class="flex justify-content-end gap-1">
                <Button type="submit" label="Salvar" severity="success" icon="pi pi-save" size="small"
                    class="flex align-items-center justify-content-center" :loading="isLoading" />
                <Button label="Fechar" severity="warn" icon="pi pi-times" size="small" @click="updateVisible(false)"
                    class="flex align-items-center justify-content-center" :loading="isLoading" />
            </div>
        </form>

        <LogForm :visible="visibleLogForm" table="clientes" :tableId="form.id" @close="this.visibleLogForm=false" />

    </Dialog>
</template>
<script>
import Dialog from 'primevue/dialog';
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';
import Select from 'primevue/select';
import InputNumber from 'primevue/inputnumber';
import InputMask from 'primevue/inputmask';
import Checkbox from 'primevue/checkbox';
import AutoComplete from 'primevue/autocomplete';
import Button from 'primevue/button';
import InputGroup from 'primevue/inputgroup';
import InputGroupAddon from 'primevue/inputgroupaddon';

import Cliente from '@/service/cliente.js';

import LogForm from '@/components/LogForm.vue';

import axios from 'axios';

export default {
    components: {
        Dialog,
        FloatLabel,
        Button,
        InputText,
        InputMask,
        Select,
        AutoComplete,
        Checkbox,
        InputNumber,
        InputGroup,
        InputGroupAddon,

        LogForm,
    },
    props: {
        visible: false,
        data: {},
    },
    emits: ['save', 'close'],
    data() {
        return {
            form: {},
            errors: {},
            isLoading: false,

            visibleLogForm: false,

            tabIndex: 0,
        }
    },
    methods: {
        onShow() {
            this.errors = {};
            this.form = Cliente.parse({ ...this.data });
        },
        onHide() {
            this.form = {};
        },
        openLogForm() {
            this.visibleLogForm = true;
        },
        updateVisible(visible) {
            this.$emit('close', visible);
        },
        save(form) {
            if (form.id) {
                return Cliente.update(form.id, form);
            }
            return Cliente.create(form);
        },
        onSubmit(form) {
            this.errors = {};
            this.isLoading = true;

            this.save(form)
                .then(response => {
                    this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: 'Seus dados foram salvos com sucesso.', life: 3000 });
                    this.form = Cliente.parse(response.data.data);
                    this.$emit('save');
                    this.$emit('close');
                })
                .catch(error => {
                    if (error.response) {
                        let err = error.response.data;
                        if (err.erros) {
                            for (let i in err.erros) {
                                this.errors[i] = err.erros[i][0];
                            }
                            return;
                        }
                        if (error.response.data.msg) {
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
                            return;
                        }
                    }
                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    }
}
</script>
